import continent from './continent-one.json'
export const tutorialLevel={id:'tutorial-hello-world',name:'第一声问候',target:'ok',hint:'放置文字物料，填写 ok，沿传送带送入出货站。'}
export const levels=continent.levels
export const regionName=continent.name
export function matchesTarget(value,target){return JSON.stringify(value)===JSON.stringify(target)}
export function evaluateDelivery(item,level){
  if(!matchesTarget(item.value,level.target))return {ok:false,reason:'成品与订单要求不一致'}
  const remaining=(item.route||[]).slice()
  const missing=(level.required||[]).filter(id=>{const index=remaining.indexOf(id);if(index<0)return true;remaining.splice(index,1);return false})
  if(missing.length)return {ok:false,reason:'货物未经指定道具加工，就到达了出货站。',missing}
  if(level.input&&(!item.origin||item.origin.type!==level.input.type||!matchesTarget(item.origin.value,level.input.value)))return {ok:false,reason:'请使用订单指定的原材料'}
  return {ok:true,reason:'订单完成'}
}
export function unlockedTools(index){
  const result=new Set(['belt','select','erase','source.number','source.string','keyword.const','keyword.let','keyword.function','keyword.return'])
  levels.slice(0,index+1).forEach(level=>{result.add(level.input.type);level.required.forEach(id=>result.add(id))})
  return result
}
